import Entity from '../../../core/domain/entity';
import UniqueEntityID from '../../../core/domain/unique_entity_id';
import { TaskId } from './task';

export const TASK_TYPES = [
  'FREE',
  'DOCUMENT',
  'NOTE',
  'SURVEY',
  'CHART',
  'MESSAGE',
  'ENCOURAGEMENT',
  'TRACKER',
  'APPOINTMENT',
  'INVOICE',
  'ESTIMATE',
  'EXTERNAL',
] as const;
export type TaskType = typeof TASK_TYPES[number];

export const TASK_DURATION_UNITS = [
  'MINUTE',
  'HOUR',
  'DAY',
  'WEEK',
  'MONTH',
  'YEAR',
] as const;
export type TaskDelayUnit = typeof TASK_DURATION_UNITS[number];

export const TASK_TARGET_TYPES = [
  'NOTHING',
  'PATIENT',
  'SELECTION_OF_PATIENTS',
] as const;
export type TaskTargetType = typeof TASK_TARGET_TYPES[number];

export type TaskStatus = 'ACTIVE' | 'INACTIVE';

export interface TaskDelay {
  unit: TaskDelayUnit;
  value: number;
}

export interface PredefinedTaskProps {
  type: TaskType;
  isNameable: boolean;
  description: string;
  delay: TaskDelay | undefined;
  targetType: TaskTargetType;
  status: TaskStatus;
}

export class PredefinedTaskId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): PredefinedTaskId {
    return new PredefinedTaskId(id);
  }
}

export class PredefinedTask extends Entity<PredefinedTaskProps> {
  get predefinedTaskId(): TaskId {
    return TaskId.create(this.id);
  }

  get description(): string {
    return this.props.description;
  }

  get delay(): TaskDelay | undefined {
    return this.props.delay;
  }

  get targetType(): TaskTargetType {
    return this.props.targetType;
  }

  get type(): TaskType | undefined {
    return this.props.type;
  }

  get isNameable(): boolean {
    return this.props.isNameable;
  }

  get status(): TaskStatus {
    return this.props.status;
  }

  get isPredefinedTask(): boolean {
    return true;
  }

  private constructor(props: PredefinedTaskProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: PredefinedTaskProps): PredefinedTask {
    return PredefinedTask.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(
    props: PredefinedTaskProps,
    id?: UniqueEntityID,
  ): PredefinedTask {
    return new PredefinedTask(props, id);
  }
}
